

import { CreateEntityInput, FieldStatusInput, Language } from 'generated/graphql';

import { EmailFormModel } from 'entity/forms/email-form/email-form.component';
import { NameFormModel } from 'entity/forms/name-form/name-form.component';
import { PhoneFormModel } from 'entity/forms/phone-form/phone-form.component';
import { AddressFormModel } from 'shared/forms/address-form/address-form.component';

export const translateToCreateEntityInput = (
  formGroupValue: any,
  entityTypeId: string,
  campaignId: string
): CreateEntityInput => {

  const nameInfo = formGroupValue.nameInfo as NameFormModel;

  const input: CreateEntityInput = {
    campaignId,
    entityTypeId,
    firstName: nameInfo.firstName,
    lastName: nameInfo.lastName,
    middleName: nameInfo.middleName,
    nickname: nameInfo.nickname,
    pronouns: nameInfo.pronouns,
    suffix: nameInfo.suffix,
    entityLanguages: (formGroupValue.entityLanguages as { languageCode: Language; preferred: boolean }[])?.map((v) => ({
      languageCode: v.languageCode,
      preferred: v.preferred
    })),
    emails: (formGroupValue.emails as EmailFormModel[])?.map((v) => ({
      email: v.email,
      emailType: v.emailType as any,
      status: v.verified ? FieldStatusInput.Verified : FieldStatusInput.UserAdded,
      subscribe: v.subscribed
    })),
    phoneNumbers: (formGroupValue.phones as PhoneFormModel[])?.map((v) => ({
      number: v.number,
      ext: v.ext,
      numberType: v.numberType,
      status: v.verified ? FieldStatusInput.Verified : FieldStatusInput.UserAdded,
      subscribe: v.subscribed
    })),
    addresses: (formGroupValue.addresses as AddressFormModel[])?.map((v) => ({
      addressType: v.addressType,
      streetAddress: v.streetAddress,
      city: v.city,
      state: v.state,
      country: v.country,
      zip: v.zip,
      status: v.verified ? FieldStatusInput.Verified : FieldStatusInput.UserAdded,
    }))
  };

  return input;
};
